export default __webpack_public_path__ + "static/media/gamification-spin-shellshock.2b0afdfc.png";